/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useApi } from '../services';

export const useCreateAccessGroupMembership = () => useApi(`/v2/access-group-membership`, 'POST', {}, {}, true);

export const useGetAccessGroupMembership = () => useApi(`/v2/access-group-membership`, 'GET', {}, {}, true);

export const useExpireAccessGroupMembership = (idGroupMembership) => useApi(`/v2/access-group-membership/${idGroupMembership}/expire`, 'DELETE', {}, {}, true);
